import { createSvgIcon } from "@mui/material";

const InvestorPortalIcon = createSvgIcon(
  <svg viewBox="0 0 49 48" fill="none">
    <path
      d="M0.399902 12.1905C0.399902 5.45786 6.13066 0 13.1999 0H35.5999C42.6691 0 48.3999 5.45786 48.3999 12.1905V35.8095C48.3999 42.5421 42.6691 48 35.5999 48H13.1999C6.13066 48 0.399902 42.5421 0.399902 35.8095V12.1905Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M16.8818 22.1307H24.4027V30.6968C24.4027 32.7737 22.7191 34.4573 20.6423 34.4573C18.5654 34.4573 16.8818 32.7737 16.8818 30.6969V22.1307Z"
      fill="#B2EBF2"
    />
    <path
      d="M23.7759 16.6765C23.7759 18.4072 22.3728 19.8103 20.6421 19.8103C18.9113 19.8103 17.5083 18.4072 17.5083 16.6765C17.5083 14.9458 18.9113 13.5427 20.6421 13.5427C22.3728 13.5427 23.7759 14.9458 23.7759 16.6765Z"
      fill="#B2EBF2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0566 10.439C20.0566 9.92354 20.4745 9.50568 20.99 9.50568H29.0252C29.2727 9.50568 29.5101 9.60401 29.6851 9.77904L36.2824 16.3763C36.4574 16.5513 36.5557 16.7887 36.5557 17.0363V33.2589C36.5557 35.5417 34.7052 37.3922 32.4224 37.3922H20.99C20.4745 37.3922 20.0566 36.9744 20.0566 36.4589C20.0566 35.9434 20.4745 35.5256 20.99 35.5256H32.4224C33.6742 35.5256 34.6891 34.5107 34.6891 33.2589V17.4229L28.6385 11.3723H20.99C20.4745 11.3723 20.0566 10.9545 20.0566 10.439Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0251 10.2387C29.5406 10.2387 29.9585 10.6566 29.9585 11.172V15.5702C29.9585 15.8647 30.1967 16.1029 30.4912 16.1029H35.6224C36.1378 16.1029 36.5557 16.5208 36.5557 17.0363C36.5557 17.5517 36.1378 17.9696 35.6224 17.9696H30.4912C29.1657 17.9696 28.0918 16.8957 28.0918 15.5702V11.172C28.0918 10.6566 28.5097 10.2387 29.0251 10.2387Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2441 22.5038C12.2441 21.9884 12.662 21.5705 13.1775 21.5705H20.2431C20.7586 21.5705 21.1764 21.9884 21.1764 22.5038V30.5514C21.1764 33.018 19.1769 35.0176 16.7103 35.0176C14.2437 35.0176 12.2441 33.018 12.2441 30.5514V22.5038ZM14.1108 23.4372V30.5514C14.1108 31.9871 15.2746 33.1509 16.7103 33.1509C18.1459 33.1509 19.3098 31.9871 19.3098 30.5514V23.4372H14.1108Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7104 14.476C15.5999 14.476 14.6997 15.3763 14.6997 16.4868C14.6997 17.5973 15.5999 18.4976 16.7104 18.4976C17.8209 18.4976 18.7212 17.5973 18.7212 16.4868C18.7212 15.3763 17.8209 14.476 16.7104 14.476ZM12.833 16.4868C12.833 14.3454 14.569 12.6094 16.7104 12.6094C18.8519 12.6094 20.5879 14.3454 20.5879 16.4868C20.5879 18.6282 18.8519 20.3642 16.7104 20.3642C14.569 20.3642 12.833 18.6282 12.833 16.4868Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9395 23.4233C25.9395 22.9079 26.3573 22.49 26.8728 22.49H30.1076C30.6231 22.49 31.041 22.9079 31.041 23.4233C31.041 23.9388 30.6231 24.3567 30.1076 24.3567H26.8728C26.3573 24.3567 25.9395 23.9388 25.9395 23.4233Z"
      fill="#29A2B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9395 28.9063C25.9395 28.3908 26.3573 27.973 26.8728 27.973H32.3236C32.8391 27.973 33.2569 28.3908 33.2569 28.9063C33.2569 29.4218 32.8391 29.8396 32.3236 29.8396H26.8728C26.3573 29.8396 25.9395 29.4218 25.9395 28.9063Z"
      fill="#29A2B1"
    />
  </svg>,
  "InvestorPortalIcon"
);

export default InvestorPortalIcon;
